// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 813300158
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { FacilitySummary } from './models/nonentity/facilitysummary';
import { Contact } from './models/anesthesiologist/contact';
import { ContractSummary } from './models/nonentity/contractsummary';
import { Document } from './models/anesthesiologist/document';
import { BlobResult } from './models/common/blobresult';
import { UploadObject } from '../shared/models/uploadobject';
import { Anesthesiologist } from './models/anesthesiologist/anesthesiologist';

export interface getFacilitiesByAnesthesiologistId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getContractsByAnesthesiologistId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getAnesthesiologistById_Filter {
  includeChildren: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AnesthesiologistsApiService {
  constructor(protected http: HttpClient) {}

  getFacilitiesByAnesthesiologistId(
    anesthesiologistGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getFacilitiesByAnesthesiologistId_Filter>
  ): Observable<SmartListResult<FacilitySummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Anesthesiologists/${anesthesiologistGuid}/facilities`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<FacilitySummary>>(url, {
      params: params,
    });
  }

  updateFacilitiesForAnesthesiologistId(
    anesthesiologistGuid: string,
    ids: string[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Anesthesiologists/${anesthesiologistGuid}/facilities`;
    return this.http.put<any>(url, ids);
  }

  getContactsByAnesthesiologistId(
    anesthesiologistGuid: string
  ): Observable<Contact[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Anesthesiologists/${anesthesiologistGuid}/contacts`;
    return this.http.get<Contact[]>(url);
  }

  updateContactsForAnesthesiologistId(
    anesthesiologistGuid: string,
    contacts: Contact[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Anesthesiologists/${anesthesiologistGuid}/contacts`;
    return this.http.put<any>(url, contacts);
  }

  getContractsByAnesthesiologistId(
    anesthesiologistGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getContractsByAnesthesiologistId_Filter>
  ): Observable<SmartListResult<ContractSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Anesthesiologists/${anesthesiologistGuid}/contracts`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ContractSummary>>(url, {
      params: params,
    });
  }

  updateContractsForAnesthesiologistId(
    anesthesiologistGuid: string,
    ids: string[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Anesthesiologists/${anesthesiologistGuid}/contracts`;
    return this.http.put<any>(url, ids);
  }

  getDocumentsByAnesthesiologistId(
    anesthesiologistGuid: string
  ): Observable<Document[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Anesthesiologists/${anesthesiologistGuid}/documents`;
    return this.http.get<Document[]>(url);
  }

  addAnesthesiologistDocuments(
    anesthesiologistGuid: string,
    documents: Document[]
  ): Observable<Document[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Anesthesiologists/${anesthesiologistGuid}/documents`;
    return this.http.post<Document[]>(url, documents);
  }

  uploadDocument(upload: UploadObject, metadata: any): Subject<void> {
    const url = environment.chiliSauceApiRoot + `/api/Anesthesiologists/upload`;

    if (!upload.file) {
      console.warn('no file specified to upload');
      return;
    }

    const subject = new Subject<void>();
    const fileToUpload = upload.file;
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    let headers: HttpHeaders = null;
    if (metadata) {
      headers = new HttpHeaders({
        UploadMetadata: JSON.stringify(metadata),
      });
    }

    this.http
      .post(url, formData, {
        reportProgress: true,
        observe: 'events',
        headers: headers,
      })
      .subscribe((event) => {
        if (event.type === HttpEventType.UploadProgress) {
          upload.progress = Math.round((100 * event.loaded) / event.total);
        } else if (event.type === HttpEventType.Response) {
          const response = <BlobResult>event.body;
          upload.url = response.blobAddress;
          subject.next();
          subject.complete();
        }
      });

    return subject;
  }

  getAllAnesthesiologists(
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<Anesthesiologist>> {
    let url = environment.chiliSauceApiRoot + `/api/Anesthesiologists`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Anesthesiologist>>(url);
  }

  addAnesthesiologist(
    newAnesthesiologist: Anesthesiologist
  ): Observable<Anesthesiologist> {
    const url = environment.chiliSauceApiRoot + `/api/Anesthesiologists`;
    return this.http.post<Anesthesiologist>(url, newAnesthesiologist);
  }

  getAnesthesiologistById(
    anesthesiologistGuid: string,
    queryParams?: Partial<getAnesthesiologistById_Filter>
  ): Observable<Anesthesiologist> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Anesthesiologists/${anesthesiologistGuid}`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<Anesthesiologist>(url, { params: params });
  }

  updateAnesthesiologist(
    anesthesiologist: Anesthesiologist,
    anesthesiologistGuid: string
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Anesthesiologists/${anesthesiologistGuid}`;
    return this.http.put<any>(url, anesthesiologist);
  }

  deleteAnesthesiologist(anesthesiologistGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Anesthesiologists/${anesthesiologistGuid}`;
    return this.http.delete(url);
  }
}
